<template>
  <b-card class="shadow" style="min-height: 700px" ref="printMe">
    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <h5 class="mb-0 text-gray-800">
            {{ $t("Gráficos de Atividades") }}
          </h5>
          <b-button-group>
            <b-button
              variant="outline-dark"
              :class="viewFilterReport === true ? 'active' : ''"
              @click="viewFilters"
            >
              <i class="fas fa-filter"></i>
              {{ $t("Filtros") }}
            </b-button>
          </b-button-group>
        </div>
      </div>

      <div class="col-md-12">
        <div class="col-12">
          <p>
            Período de pesquisa selecionado:
            <b>{{ report.datas.start }} - {{ report.datas.end }}</b>
            <b-link
              href="#"
              @click.prevent="void 0"
              class="mb-2"
              variant="info"
              v-b-popover.hover.top="
                'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
              "
            >
              <i class="fas fa-info-circle"></i>
            </b-link>
          </p>
        </div>
        <div class="col-12 no-print" v-if="viewFilterReport">
          <!-- Filtros -->
          <form @submit.prevent="getAnalytics" ref="addItem">
            <div class="row">
              <form-calendar
                v-model="data_inicio"
                grid="6"
                label="Data Inicial"
                :max-date="dataNow"
              />

              <form-calendar
                v-model="data_fim"
                grid="6"
                label="Data final"
                :required="verificaDataInicial"
                :min-date="data_inicio"
                :max-date="dataNow"
              />
            </div>
            <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
              <div class="col-auto px-2 text-right">
                <button
                  class="btn btn-default"
                  @click.prevent="limparFiltros(), (viewFilterReport = false)"
                >
                  <i class="fas fa-times"></i>
                </button>

                <button
                  type="button"
                  class="btn btn-secondary"
                  @click.prevent="limparFiltros()"
                >
                  {{ $t("Limpar Filtros") }}
                </button>

                <button
                  class="btn btn-success btn-submit"
                  data-style="zoom-in"
                  type="submit"
                >
                  <i class="fas fa-chart-bar"></i>
                  {{ $t("Gerar Gráfico") }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="col-12" id="boxPrint">
        <b-tabs content-class="mt-3">
          <b-tab title="Por Unidades" @click.prevent="changeTab('Por Unidades')">
            <div class="row">
              <div class="col-md-12" v-if="tabAtiva == 'Por Unidades'">
                <loading-animation
                  :active.sync="loading"
                  :is-full-page="false"
                  :opacity="1"
                  color="#5895FF"
                />
                <span v-if="report.por_unidades.length == 0">
                  <div class="row align-items-center text-center empty-graph">
                    <div class="col">
                      <img
                        :alt="$t('No results')"
                        class="mb-3"
                        src="/img/graphics/statistic_chart.svg"
                        style="max-height: 100px"
                      />
                      <h5>{{ $t("No records available") }}</h5>
                    </div>
                  </div>
                </span>
                <bar-chart v-else :data="report.por_unidades"></bar-chart>
              </div>
            </div>
          </b-tab>
          <b-tab title="Por Status" @click.prevent="changeTab('Por Status')">
            <div class="row">
              <div class="col-md-12" v-if="tabAtiva == 'Por Status'">
                <loading-animation
                  :active.sync="loading"
                  :is-full-page="false"
                  :opacity="1"
                  color="#5895FF"
                />
                <span v-if="report.por_status.length == 0">
                  <div class="row align-items-center text-center empty-graph">
                    <div class="col">
                      <img
                        :alt="$t('No results')"
                        class="mb-3"
                        src="/img/graphics/statistic_chart.svg"
                        style="max-height: 100px"
                      />
                      <h5>{{ $t("No records available") }}</h5>
                    </div>
                  </div>
                </span>
                <pie-chart
                  v-else
                  :donut="true"
                  :data="report.por_status"
                  height="600px"
                ></pie-chart>
              </div>
            </div>
          </b-tab>
          <b-tab title="Por Tipos" @click.prevent="changeTab('Por Tipos')">
            <div class="row">
              <div class="col-md-12" v-if="tabAtiva == 'Por Tipos'">
                <loading-animation
                  :active.sync="loading"
                  :is-full-page="false"
                  :opacity="1"
                  color="#5895FF"
                />

                <span v-if="report.por_tipos.length == 0">
                  <div class="row align-items-center text-center empty-graph">
                    <div class="col">
                      <img
                        :alt="$t('No results')"
                        class="mb-3"
                        src="/img/graphics/statistic_chart.svg"
                        style="max-height: 100px"
                      />
                      <h5>{{ $t("No records available") }}</h5>
                    </div>
                  </div>
                </span>
                <pie-chart
                  v-else
                  :donut="true"
                  :data="report.por_tipos"
                  height="600px"
                ></pie-chart>
              </div>
            </div>
          </b-tab>

          <b-tab
            title="Por Participações"
            @click.prevent="changeTab('Por Participações')"
          >
            <div class="row">
              <form-select
                grid="6"
                label="Ano"
                :itens="years"
                v-model="filtroYear"
                @change="getAnalytics()"
              />

              <form-select
                grid="6"
                label="Mês"
                :itens="months"
                v-model="filtroMonth"
                placeholder="Selecione um mês"
                @change="getAnalytics()"
              />
            </div>

            <div class="row">
              <div class="col-md-12" v-if="tabAtiva == 'Por Participações'">
                <loading-animation
                  :active.sync="loading"
                  :is-full-page="false"
                  :opacity="1"
                  color="#5895FF"
                />

                <span v-if="report.por_participantes.length == 0">
                  <div class="row align-items-center text-center empty-graph">
                    <div class="col">
                      <img
                        :alt="$t('No results')"
                        class="mb-3"
                        src="/img/graphics/statistic_chart.svg"
                        style="max-height: 100px"
                      />
                      <h5>{{ $t("No records available") }}</h5>
                    </div>
                  </div>
                </span>
                <area-graph
                  v-else
                  :loading="loading"
                  :data="report.por_participantes"
                  titulo="Usuários com participação confirmada em atividades do SCFV"
                  :range="range"
                  sizearea="300px"
                  sizecard="375px"
                  tipo="participantes"
                />
                <!-- <area-chart v-else :data="report.por_participantes"></area-chart> -->
                <!-- <pie-chart
                  v-else
                  :donut="true"
                  :data="report.por_participantes"
                  height="600px"
                ></pie-chart> -->
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
      <div class="col-md-12 text-center mt-3">
        <b-button
          :title="$t('Imprimir')"
          class="py-2"
          size="sm"
          type="button"
          v-b-tooltip.hover
          variant="primary"
          @click="printHtml()"
        >
          <i class="fas fa-print"></i>
        </b-button>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "AtividadesGraficos",
  data() {
    return {
      loading: true,
      report: {
        por_status: [],
        por_tipos: [],
        por_unidades: [],
        datas: {
          start: "",
          end: "",
        },
      },
      filtros: {},
      tabAtiva: "Por Unidades",
      dataNow: moment().format("YYYY/MM/DD"),
      range: "yearly",
      years: [],
      months: [],
      filtroYear: moment().format("YYYY"),
      filtroMonth: null,
    };
  },
  mounted() {
    this.getAnalytics();
  },

  methods: {
    changeTab(value) {
      if (value) {
        this.tabAtiva = value;
      } else {
        this.tabAtiva = "Por Unidades";
      }
      this.getAnalytics();
    },
    updateAnalytics(range) {
      if (this.range !== range) {
        this.range = range;
        this.getAnalytics();
      }
    },
    getAnalytics() {
      if (this.data_inicio) {
        this.filtros.data_inicial = this.$options.filters.formatDateYMD(this.data_inicio);
      }
      if (this.data_fim) {
        this.filtros.data_final = this.$options.filters.formatDateYMD(this.data_fim);
      }

      if (this.filtroMonth) {
        this.range = "monthly";
      } else {
        this.range = "yearly";
      }

      this.loading = true;
      const tab = { tab: this.tabAtiva };
      axios
        .get("api/dashboard/report/atividades/graficos", {
          params: {
            range: this.range,
            filtros: this.filtros,
            ...tab,
            filtroYear: this.filtroYear,
            filtroMonth: this.filtroMonth,
          },
        })
        .then((response) => {
          this.report = response.data.data;
          this.years = response.data.data.years;
          this.months = response.data.data.months;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    limparFiltros() {
      this.filtros.data_inicial = null;
      this.filtros.data_final = null;
      this.data_inicio = null;
      this.data_fim = null;
      this.getAnalytics();
    },
  },
};
</script>
